import { Component, OnInit, ViewChild, EventEmitter, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { Aguas, PersonaClientes, BuscaTramite, } from "../../entidades/entidades"; // prettier-ignore
import { EstadoCuentaInformacionInput } from "../../entidades/entidades"; // prettier-ignore
import { BuscaPersonaClientesService } from "../../servicios/busca-persona-clientes.service";
import { SolicitudDetallesGridComponent } from '../../componentes/solicitud-detalles-grid/solicitud-detalles-grid.component';

@Component({
  selector: 'app-ventanilla',
  templateUrl: './ventanilla.component.html',
  styleUrls: ['./ventanilla.component.css']
})
export class VentanillaComponent implements OnInit {
  //Generales 
  muestraMensaje = new MuestraMensaje();
  @ViewChild(SolicitudDetallesGridComponent, { static: false }) childSolicitudDetallesGrid;
  @Output("aguasOutput") aguasOutput: EventEmitter<number>;

  // Para la busqueda del cliente
  datosPClientesForm: FormGroup;
  datosClientes = new PersonaClientes();
  buscando: boolean = false;

  // Para la busqueda de cuenta de agua
  public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;

  constructor(
    private buscaPersonaClientesService: BuscaPersonaClientesService,
    private formBuilder: FormBuilder,
  ) { 
    this.aguasOutput = new EventEmitter();
  }

  ngOnInit() {
    this.datosPClientesForm = this.formBuilder.group({
      idPersonaCliente: [undefined],
      nRazonSocial: [undefined],
      domicilio: [undefined],
    });
    this.BuscaClienteDefault();

  }

  // ****************************************************************************************** 
  // Busqueda de cuenta de agua
  // ******************************************************************************************

  async childAguaBuscaCuentas(idAgua: number) {
    if (!idAgua) {
      this.estadoCuentaInformacionInput$.emit(null);
      return;
    }

    //this.datosSolicitud.idAgua = aguas.id;
    //Carga formulario estado-cuentas
    let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
    estadoCuentaInformacionInput.idAgua = idAgua;

    this.estadoCuentaInformacionInput$.emit(estadoCuentaInformacionInput);
    this.childSolicitudDetallesGrid.idAgua = idAgua;
  }


  // ******************************************************************************************
  // Busqueda de  solicitante
  // ******************************************************************************************

  //====================================================
  //Componente Hijos
  //====================================================
  async childPersonaClientes(personaClientes: PersonaClientes) {
    this.datosPClientesForm.value.idPersonaCliente = personaClientes.id;
    this.buscaSolicitante();
  }

  //====================================================
  //Eventos BuscaClientes
  //====================================================
  async BuscaClienteDefault()
  {
    try 
    {
      let cliente = new PersonaClientes();
      cliente.id = 1;
      const datoretorno = await this.buscaPersonaClientesService.add(cliente).toPromise();

      /*if (Object.keys(datoretorno).length == 0) {
        this.datosPClientesForm.reset();
        this.muestraMensaje.error("No se encontro registro.", "top", "center");
      }*/

      let buscaPersonaClientes = datoretorno[0];

      //DatosCliente
      let nomRazon;
      if (buscaPersonaClientes.nombreCliente.trim() != "") {
        nomRazon = buscaPersonaClientes.nombreCliente.toString();
      } else {
        nomRazon = buscaPersonaClientes.razonSocial.toString();
      }
      await this.datosPClientesForm.patchValue({
        idPersonaCliente: buscaPersonaClientes.id,
        nRazonSocial: nomRazon,
        domicilio: buscaPersonaClientes.domicilio,
      });

      this.childSolicitudDetallesGrid.idPersonaCliente = buscaPersonaClientes.id;

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }
  //====================================================
  //Eventos BuscaPersonaClientes
  //====================================================
  // prettier-ignore
  async buscaSolicitante() {
    if (this.buscando) {
      return;
    }
    try {
      this.datosClientes.id = this.datosPClientesForm.value.idPersonaCliente;
      if (this.datosClientes.id == null) {
        this.muestraMensaje.error("Ingresa un folio para la busqueda", "top", "center");
        return;
      }

      const datoretorno = await this.buscaPersonaClientesService.add(this.datosClientes).toPromise();
      this.buscando = false;
      if (Object.keys(datoretorno).length == 0) {
        this.datosPClientesForm.reset();
        this.muestraMensaje.error("No se encontro registro.", "top", "center");
      }

      let buscaPersonaClientes = datoretorno[0];

      //DatosCliente
      let nomRazon;
      if (buscaPersonaClientes.nombreCliente.trim() != "") {
        nomRazon = buscaPersonaClientes.nombreCliente.toString();
      } else {
        nomRazon = buscaPersonaClientes.razonSocial.toString();
      }
      await this.datosPClientesForm.patchValue({
        idPersonaCliente: buscaPersonaClientes.id,
        nRazonSocial: nomRazon,
        domicilio: buscaPersonaClientes.domicilio,
      });
      this.muestraMensaje.notification("Registro encontrado.", "top", "center"
      );

      this.childSolicitudDetallesGrid.idPersonaCliente = buscaPersonaClientes.id;

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  

  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.buscaSolicitante();
    }
  }

  // se crea metodo que recibe la informacion emitida por el componente solicitu-detalles-grid
  //si el id emitido es =0 es por que se a guardado la solicitud y se seleccionara el usuario por default
  async childSolicitud (Solicitud:BuscaTramite){
    if(Solicitud.id==0){
      this.buscaSolicitante()
    }
  }

}
